import { __spreadArray } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import { useVeltClient } from "../../context";
// import HighchartsReact from 'highcharts-react-official';
// import Highcharts from 'highcharts';
import VeltChartComment from "../VeltChartComment";
var HighchartsReact;
var Highcharts;
// optionally import highcharts modules using try catch
try {
    HighchartsReact = require('highcharts-react-official');
    Highcharts = require('highcharts');
}
catch (err) {
    HighchartsReact = null;
    Highcharts = null;
}
var VeltHighChartComments = function (_a) {
    var chartComputedData = _a.chartComputedData, id = _a.id, dialogMetadataTemplate = _a.dialogMetadataTemplate;
    var _b = useState([]), points = _b[0], setPoints = _b[1];
    var _c = useState([]), ghostPoints = _c[0], setGhostPoints = _c[1];
    var chartRef = useRef(chartComputedData);
    var commentsRef = useRef([]);
    var client = useVeltClient().client;
    var _d = React.useState(null), documentPathsSubscription = _d[0], setDocumentPathsSubscription = _d[1];
    var _e = useState(null), commentSubscription = _e[0], setCommentSubscription = _e[1];
    // Unsubscribe from the subscriptions when the component is unmounted
    useEffect(function () {
        return function () {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
        };
    }, []);
    useEffect(function () {
        if (client) {
            getCommentAnnotations();
        }
    }, [client]);
    var getCommentAnnotations = function () {
        var _a;
        try {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
            if (client) {
                var subscription = (_a = client === null || client === void 0 ? void 0 : client.docService) === null || _a === void 0 ? void 0 : _a.getDocumentPaths$().subscribe(function (paths) {
                    var _a;
                    if (paths === null || paths === void 0 ? void 0 : paths.clientDocumentId) {
                        unsubscribeCommentSubscription();
                        var commentElement = client.getCommentElement();
                        var subscription_1 = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations(paths === null || paths === void 0 ? void 0 : paths.clientDocumentId)) === null || _a === void 0 ? void 0 : _a.subscribe(function (comments) {
                            commentsRef.current = comments;
                            filterGhostComments(comments);
                        });
                        setCommentSubscription(subscription_1);
                    }
                });
                setDocumentPathsSubscription(subscription);
            }
        }
        catch (err) {
        }
    };
    var filterGhostComments = function (comments) {
        var _a;
        try {
            var chartComments = (_a = comments === null || comments === void 0 ? void 0 : comments.filter(function (annotation) { return annotation.commentType === 'chart'; })) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { var _a; return ((_a = annotation === null || annotation === void 0 ? void 0 : annotation.metadata) === null || _a === void 0 ? void 0 : _a.id) === id; });
            var ghostPoints_1 = [];
            chartComments.forEach(function (annotation) {
                var metadata = annotation.metadata;
                var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                if (groupId && value && label) {
                    var series = chartRef.current.chart.series.find(function (series) { return series.name === groupId; });
                    if (series === null || series === void 0 ? void 0 : series.visible) {
                        switch (series.type) {
                            case 'line':
                                var linePoint = series.points.find(function (point) { return point.y === value && point.x === label; });
                                if (!linePoint) {
                                    var x = series.xAxis.toPixels(label, true);
                                    var y = series.yAxis.toPixels(value, true);
                                    ghostPoints_1.push({
                                        x: x,
                                        y: y,
                                        seriesName: groupId,
                                        yValue: value,
                                        transform: 'translate(-50%, -150%)',
                                        id: "".concat(groupId, "-").concat(label, "-").concat(value),
                                        metadata: {
                                            id: id,
                                            groupId: groupId,
                                            label: label,
                                            value: value,
                                        },
                                    });
                                }
                                break;
                            case 'bar':
                            case 'column':
                                var barPoint = series.points.find(function (point) { return point.y === value && point.category === label; });
                                if (!barPoint) {
                                    var categoryIndex = series.xAxis.categories.indexOf(label);
                                    var x = series.xAxis.toPixels(categoryIndex, true);
                                    var y = series.yAxis.toPixels(value, true);
                                    // const width = series.xAxis.toPixels(categoryIndex + 1, true) - x;
                                    ghostPoints_1.push({
                                        x: x,
                                        y: y,
                                        seriesName: groupId,
                                        yValue: value,
                                        id: "".concat(groupId, "-").concat(label, "-").concat(value),
                                        // width: width,
                                        transform: 'translate(-50%, -100%)',
                                        metadata: {
                                            id: id,
                                            groupId: groupId,
                                            label: label,
                                            value: value,
                                        },
                                    });
                                }
                        }
                    }
                }
            });
            setGhostPoints(ghostPoints_1);
        }
        catch (err) {
        }
    };
    useEffect(function () {
        // Attach the redraw event listener when the chart updates
        if (chartRef.current && chartRef.current.chart) {
            var currentChart_1 = chartRef.current.chart;
            window.chart = currentChart_1;
            // Define the callback to execute on chart redraw
            var onRedraw_1 = function () {
                calculatePoints('186');
                filterGhostComments(commentsRef.current);
            };
            if (Highcharts) {
                // Attach the event listener
                Highcharts.addEvent(currentChart_1, 'redraw', onRedraw_1);
            }
            // Perform the initial calculation
            calculatePoints('194');
            // Clean up the event listener when the component unmounts or chart changes
            return function () {
                if (Highcharts) {
                    Highcharts.removeEvent(currentChart_1, 'redraw', onRedraw_1);
                }
            };
        }
    }, [chartComputedData]);
    var calculatePoints = function (from) {
        var _a, _b;
        if (!((_b = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.chart) === null || _b === void 0 ? void 0 : _b.series)) {
            return;
        }
        // Create an array of points from all series
        var newPoints = chartRef.current.chart.series.filter(function (series) { return series.visible; }).reduce(function (acc, series) {
            var seriesPoints = [];
            switch (series.type) {
                case 'line':
                    seriesPoints = series.points.map(function (point) { return ({
                        x: point.plotX,
                        y: point.plotY,
                        seriesName: series.name,
                        yValue: point.y,
                        transform: 'translate(-50%, -150%)',
                        id: "".concat(series.name, "-").concat(point.x, "-").concat(point.y),
                        metadata: {
                            id: id,
                            groupId: series.name,
                            label: point.x,
                            value: point.y,
                        },
                    }); });
                    break;
                case 'bar':
                case 'column':
                    seriesPoints = series.points.map(function (point) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var x = (_a = point.shapeArgs) === null || _a === void 0 ? void 0 : _a.x;
                        var y = (_b = point.shapeArgs) === null || _b === void 0 ? void 0 : _b.y;
                        var transform = 'translate(-50%, -100%)';
                        var width = (_c = point.shapeArgs) === null || _c === void 0 ? void 0 : _c.width;
                        var height = (_d = point.shapeArgs) === null || _d === void 0 ? void 0 : _d.height;
                        if (series.type === 'column') {
                            // Center horizontally for columns
                            x += point.shapeArgs.width / 2;
                        }
                        else if (series.type === 'bar') {
                            // Center vertically for bars
                            // y += point.shapeArgs!.height / 2;
                            x = (_e = point.shapeArgs) === null || _e === void 0 ? void 0 : _e.brBoxHeight;
                            transform = null;
                            height = (_f = point.shapeArgs) === null || _f === void 0 ? void 0 : _f.width;
                            width = null;
                            // y = (point.shapeArgs?.x! / 2) + (point.shapeArgs?.width! / 2);
                            // x = point.plotX! - (point?.shapeArgs?.width! / 2);
                            y = (_g = point.shapeArgs) === null || _g === void 0 ? void 0 : _g.x;
                        }
                        return {
                            x: x,
                            y: y,
                            seriesName: series.name,
                            yValue: point.y,
                            id: "".concat(series.name, "-").concat(point.x, "-").concat(point.y),
                            width: width,
                            // height: height,
                            transform: transform,
                            metadata: {
                                id: id,
                                groupId: series.name,
                                label: point.category,
                                value: point.y,
                            },
                        };
                    });
                    break;
            }
            return __spreadArray(__spreadArray([], acc, true), seriesPoints, true);
        }, []);
        setPoints(newPoints);
    };
    var unsubscribeDocumentPathsSubscription = function () {
        try {
            if (documentPathsSubscription) {
                documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    var unsubscribeCommentSubscription = function () {
        try {
            if (commentSubscription) {
                commentSubscription === null || commentSubscription === void 0 ? void 0 : commentSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    return (React.createElement("div", { className: 'velt-chart-comments-container', style: {
            zIndex: 100000,
            position: 'absolute',
            top: 0,
            left: 0,
        } },
        React.createElement("style", null, "\n                        .velt-chart-comments-container .point-container {\n                            opacity: 0 !important;\n                            visibility: hidden !important;\n                        }\n                    "),
        points.map(function (point, index) { return (React.createElement("div", { key: index, style: {
                position: 'absolute',
                left: "".concat(chartRef.current.chart.plotLeft + point.x, "px"),
                top: "".concat(chartRef.current.chart.plotTop + point.y, "px"),
                transform: point.transform,
                padding: '2px 5px',
                color: '#fff',
                borderRadius: '3px',
                fontSize: '10px',
                width: "".concat(point.width, "px"),
                height: "".concat(point.height, "px"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                boxSizing: 'border-box',
            } },
            React.createElement(VeltChartComment, { commentMetadata: point.metadata, dialogMetadataTemplate: dialogMetadataTemplate || point.dialogMetadataTemplate || ['groupId', 'label', 'value'] }))); }),
        ghostPoints.map(function (point, index) { return (React.createElement("div", { id: point.id, key: index, style: {
                position: 'absolute',
                left: "".concat(chartRef.current.chart.plotLeft + point.x, "px"),
                top: "".concat(chartRef.current.chart.plotTop + point.y, "px"),
                transform: point.transform,
                padding: '2px 5px',
                color: '#fff',
                borderRadius: '3px',
                fontSize: '10px',
                width: "".concat(point.width, "px"),
                height: "".concat(point.height, "px"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                boxSizing: 'border-box',
            } },
            React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: point.metadata, dialogMetadataTemplate: dialogMetadataTemplate || point.dialogMetadataTemplate || ['groupId', 'label', 'value'] }))); })));
};
export default VeltHighChartComments;
